import { RefObject, useLayoutEffect, useState } from "react";
import { useTheme } from "@mui/material/styles";

type BreakpointQuery = (theme: any) => string;

function buildQueryTester(queryString: string) {
  const match = queryString.match(/\d+/);
  const value = match ? parseInt(match[0], 10) : 0;

  if (queryString.includes("min-width")) {
    return (width: number) => width >= value;
  }
  if (queryString.includes("max-width")) {
    return (width: number) => width <= value;
  }

  return () => false;
}

export function useContainerQuery(
  ref: RefObject<HTMLElement>,
  query: BreakpointQuery,
): boolean {
  const theme = useTheme();
  const [matches, setMatches] = useState(false);

  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return;

    const queryString = query(theme);
    const test = buildQueryTester(queryString);

    const observer = new ResizeObserver(([entry]) => {
      const width = entry.contentRect.width;
      setMatches(test(width));
    });
    setMatches(test(el.getBoundingClientRect().width));
    observer.observe(el);
    return () => observer.disconnect();
  }, [ref, query, theme]);

  return matches;
}
